export function DeployCommit() {
  return (
    <span
      className="font-mono text-[11px] leading-none text-text-muted"
      title="Deployed commit"
    >
      {__APP_COMMIT__}
    </span>
  )
}
